const environmentVariables = import.meta.env;

export { environmentVariables };
